import XpBar from './XpBar';

export default XpBar;
export { XpBar };
